<div class="container">
  <div class="lottie-container">
    <!-- <ng-lottie width="650px" [options]="animationOptions"></ng-lottie> -->
  </div>

  <div class="error">
    <h1>{{ 'errors.not-found.dashboard-not-found-title' | translate }}</h1>
    <p>
      {{ 'errors.not-found.dashboard-not-found-message' | translate }}
    </p>
    <button class="btn btn-primary"> {{ 'errors.not-found.browser-dashboards' | translate }}</button>
  </div>
</div>